import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getCurrentYear, getInlineLoader } from "../Helpers";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaWhatsapp } from "react-icons/fa";
import { MdEmail, MdLocationOn, MdPhone } from "react-icons/md";
import logo from "../assets/logo.png";
import { companyInfo, services, socialLinks } from "./RunzeweContent";

const socialIcons = {
  Facebook: <FaFacebookF />,
  Instagram: <FaInstagram />,
  WhatsApp: <FaWhatsapp />,
};

export default function Footer() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (!ready) {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }

  return (
    <footer className="site-footer" data-aos="fade-up">
      <div className="container">
        <div className="footer-main">
          <div className="footer-brand">
            <div className="footer-logo" onClick={() => appContext.navTo({ item: "home" })}>
              <img src={logo} alt="Runzewe Security" />
              <strong>Runzewe Security</strong>
            </div>
            <p>
              Delivering professional security services with integrity,
              reliability, and excellence across Tanzania.
            </p>
          </div>

          <div className="footer-col">
            <h3>Quick Links</h3>
            <button onClick={() => appContext.navTo({ item: "home" })}>Home</button>
            <button onClick={() => appContext.navTo({ item: "about", subItem: "overview" })}>About</button>
            <button onClick={() => appContext.navTo({ item: "services" })}>Services</button>
            <button onClick={() => appContext.navTo({ item: "clients" })}>Clients</button>
            <button onClick={() => appContext.navTo({ item: "contact" })}>Contact</button>
          </div>

          <div className="footer-col">
            <h3>Services</h3>
            {services.slice(0, 5).map((service) => (
              <button key={service.title} onClick={() => appContext.navTo({ item: "services" })}>
                {service.title}
              </button>
            ))}
          </div>

          <div className="footer-col footer-contact">
            <h3>Contact</h3>
            <span>
              <MdPhone />
              {companyInfo.phone}
            </span>
            <span>
              <MdEmail />
              {companyInfo.email}
            </span>
            <span>
              <MdLocationOn />
              Geita, Tanzania
            </span>

            <div className="footer-socials">
              {socialLinks.map((link) => (
                <a key={link.label} href={link.url} target="_blank" rel="noreferrer" aria-label={link.label}>
                  {socialIcons[link.label]}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <span>&copy; {getCurrentYear()} Runzewe Security Company Limited. All rights reserved.</span>
          <span>Website developed by <a href={companyInfo.developerUrl} target="_blank" rel="noreferrer">
            {companyInfo.websiteDeveloper}
          </a></span>
          
        </div>
      </div>
    </footer>
  );
}
